import { z } from 'zod';

export const usersControllerUpdateMe200Schema = z.boolean();

export const usersControllerUpdateMe400Schema = z.object({
  statusCode: z.enum(['400']),
  message: z.string(),
  type: z.enum(['InvalidData']),
  details: z.object({
    location: z.enum(['path', 'query', 'body']),
    explanation: z.object({
      issues: z.array(
        z
          .object({
            code: z.enum([
              'invalid_type',
              'invalid_literal',
              'custom',
              'invalid_union',
              'invalid_union_discriminator',
              'invalid_enum_value',
              'unrecognized_keys',
              'invalid_arguments',
              'invalid_return_type',
              'invalid_date',
              'invalid_string',
              'too_small',
              'too_big',
              'invalid_intersection_types',
              'not_multiple_of',
              'not_finite',
            ]),
            path: z.array(z.union([z.string(), z.number()])),
            message: z.string(),
          })
          .catchall(z.unknown()),
      ),
    }),
  }),
});

export const usersControllerUpdateMe401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const usersControllerUpdateMe403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const usersControllerUpdateMe404Schema = z.object({
  statusCode: z.enum(['404']),
  message: z.string(),
  type: z.enum(['ObjectNotFound']),
  details: z.enum(['null']).nullable(),
});

export const usersControllerUpdateMe409Schema = z.object({
  statusCode: z.enum(['409']),
  message: z.string(),
  type: z.enum(['UniqueViolation']),
  details: z.object({ attributes: z.array(z.string()) }),
});

export const usersControllerUpdateMeMutationRequestSchema = z.union([
  z.object({
    firstName: z.string().min(2).max(64).optional(),
    lastName: z.string().min(2).max(64).optional(),
    email: z.string().email().optional(),
    backupEmail: z.string().email().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
    username: z.string().optional().nullable(),
    avatar: z.string().optional().nullable(),
    description: z.string().min(3).max(255).optional().nullable(),
    timeZone: z.string().optional().nullable(),
  }),
  z.object({
    firstName: z.string().min(2).max(64).optional(),
    lastName: z.string().min(2).max(64).optional(),
    email: z.string().email().optional(),
    backupEmail: z.string().email().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
    username: z.string().optional().nullable(),
    avatar: z.string().optional().nullable(),
    description: z.string().min(3).max(255).optional().nullable(),
    timeZone: z.string().optional().nullable(),
    speciality: z.string().optional().nullable(),
    language: z
      .enum(['eng', 'fra', 'spa', 'deu', 'ita', 'ukr'])
      .default('eng')
      .optional()
      .nullable(),
  }),
]);

export const usersControllerUpdateMeMutationResponseSchema = z.boolean();
